"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deployments = {
    goerli: "",
    mumbai: "0x3FA9F5A2bF41a7F0836fE97d011C81DFEb4AeB81",
    matic: "",
    ethereum: "",
};
exports.default = deployments;
